import { styled } from '@nykaa/ui-components';
import { DWEB_MAX_WIDTH } from 'shared/styles/base';

export const Container = styled.div<{ marginTop?: number }>`
  width: 100%;
  margin-bottom: ${({ theme }) => theme.spacing.spacing100};
  max-width: ${DWEB_MAX_WIDTH}px;
  margin: 0 auto;

  ${({ marginTop }) => marginTop && `margin-top: ${marginTop}px`}
`;

export const CarouselContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-content: center;
  scroll-snap-type: x mandatory;
`;
